export { ProductDetailsNutritionEntriesItem } from './ProductDetailsNutritionEntriesItem';
